export default __webpack_public_path__ + "static/media/south-kore.d675842b.png";